import axios from "axios";
import { PROVIDERS_ADMIN_CUSTOMER } from "../../../../../config";
import { DataTableHelper } from "../../../../../utilities/helpers/DataTableHelper";

export function getProviderCustomers(
	sortParam,
	pageSize,
	pageNumber,
	searchParam = '',
	createDateParam = '',
	filterStatusParams = [],
	filterPaymentStatusParams = []
) {
	return axios.get(
		PROVIDERS_ADMIN_CUSTOMER +
		(DataTableHelper.prepareParameters(
			sortParam,
			pageSize,
			pageNumber,
			null,
			searchParam,
			createDateParam,
			filterStatusParams,
			filterPaymentStatusParams
		)),
	);
}
export function getProviderCustomer(CutomerId) {
	return axios.get(PROVIDERS_ADMIN_CUSTOMER + '/' + CutomerId);
}